import { gql, QueryResult, useQuery } from "@apollo/client";

import {
  PublicSharedCollectionAccessTokenQuery,
  PublicSharedCollectionQuery,
  PublicSharedCollectionQueryResult,
} from "../../../generated/gql/graphql";

const GET_EXTERNAL_LINK = gql`
  query PublicSharedCollectionAccessToken(
    $publicSharedCollectionAccessTokenId: String!
  ) {
    publicSharedCollectionAccessToken(
      id: $publicSharedCollectionAccessTokenId
    ) {
      suspended
      startDate
      id
      expirationDate
      createdBy
      collectionId
    }
  }
`;

const GET_EXTERNAL_LINKS = gql`
  query PublicSharedCollectionAccessTokens(
    $query: PublicSharedCollectionQuery
  ) {
    publicSharedCollectionAccessTokens(query: $query) {
      items {
        suspended
        startDate
        id
        expirationDate
        createdBy
        collectionId
      }
    }
  }
`;

function useExternalLink(
  publicSharedCollectionAccessTokenId: string
): QueryResult<PublicSharedCollectionAccessTokenQuery> {
  return useQuery<PublicSharedCollectionAccessTokenQuery>(GET_EXTERNAL_LINK, {
    variables: {
      publicSharedCollectionAccessTokenId,
    },
  });
}

function useExternalLinks(
  query?: PublicSharedCollectionQuery
): QueryResult<PublicSharedCollectionQueryResult> {
  return useQuery<PublicSharedCollectionQueryResult>(GET_EXTERNAL_LINKS, {
    variables: {
      query,
    },
  });
}

export { useExternalLink, useExternalLinks };
